// extracted by mini-css-extract-plugin
export var filterButton = "_mg-1";
export var filtersContainer = "_mg-0";